export const ColumnTypes = {
  TEXT: 'text',
  NUMBER: 'number',
  DATE: 'date',
  FAVOURITE: 'favourite',
  BADGE: 'badge',
  BADGES: 'badges',
  AVATAR: 'avatar',
  BUTTON: 'button',
  INPUT_NUMBER: 'inputNumber',
  INPUT_TEXT: 'inputText',
  CUSTOM: 'custom',
  LIST: 'list',
  DATE_WITH_DIFF: 'dateWithDiff',
  OVERFLOWING_TEXT: 'overflowingText',
  IMAGE: 'image',
};

export const SortOrders = {
  ASC: 'asc',
  DESC: 'desc',
};

export const RowOverrides = {
  DISABLE_SELECTION: '__tbl_disableSelection',
  DISABLED_ACTIONS: '__tbl_disabledActions',
  INVISIBLE_ACTIONS: '__tbl_invisibleActions',
  DISABLE_KEBAB_MENU: '__tbl_disableKebabMenu',
  EDITABLE: '__tbl_editable',
  FORCED_INPUT_ERRORS: '__tbl_forcedInputErrors',
};

export const TableStyles = {
  BOX_SHADOW: 'box-shadow',
};
